import { useEffect, useRef, useState } from 'react';

import { UseAccordionProps } from './types';

// in order to work this you have to add overflow: hidden to the ref element and some transitions
// duration should be equal to the transition duration
const useAccordion = ({
  shortListRef,
  isOpened,
  duration = 300,
  closedHeight = 0,
  onStateChange,
}: UseAccordionProps) => {
  const timeoutRef = useRef<any>(0);
  const isShortListOpened = useRef<boolean>(isOpened);
  const [height, setHeight] = useState<string>(isOpened ? 'auto' : `${closedHeight}px`);

  const handleAccordionOpen = () => {
    if (!timeoutRef.current) {
      const newIsOpen = !isShortListOpened.current;
      isShortListOpened.current = newIsOpen;
      onStateChange?.(newIsOpen);

      if (shortListRef.current) {
        if (isShortListOpened.current) {
          setHeight(`${shortListRef.current.scrollHeight}px`);
          timeoutRef.current = setTimeout(() => {
            setHeight('auto');
            timeoutRef.current = null;
          }, duration);
        } else {
          setHeight(`${shortListRef.current.scrollHeight}px`);
          timeoutRef.current = setTimeout(() => {
            setHeight(`${closedHeight}px`);
            timeoutRef.current = null;
          }, 0);
        }
      }
    }
  };

  useEffect(() => {
    return () => clearTimeout(timeoutRef.current as NodeJS.Timeout);
  }, []);

  return { handleAccordionOpen, height, isShortListOpened };
};

export default useAccordion;
